(function () {
  'use strict';

  const root = document.querySelector('[data-ctb5]');
  if (!root) return;

  const STORAGE_KEY = 'tdCustomWatBuilderV5';
  const STATE_PARAM = 'wq5';

  // ===== Block data from DOM JSON =====
  const tapeColorBlocks = (function() {
    const parsed = JSON.parse((document.getElementById('ctb5-tape-colors') || {}).textContent || '[]');
    if (parsed.length) return parsed;
    return [
      { handle: 'kraft', name: 'Kraft (Natural)',  hex: '#C9A57B', tier: 'neutral', pantone_code: '' },
      // White is a NEUTRAL colour and has never been charged for on either side:
      // tape_color_modes.neutral.modifier_pct is 0, applyModifiers() applies only
      // the print_colors modifier, and the server's computeTapePrice() reads
      // tape_color_modes['neutral'] for WAT. The old "+50% for black ink" label
      // was copy, not behaviour (brief §6.1, owner decision 2026-08-28).
      { handle: 'white', name: 'White', hex: '#FFFFFF', tier: 'neutral', pantone_code: '' },
    ];
  }());
  const inkColorBlocks = (function() {
    const parsed = JSON.parse((document.getElementById('ctb5-ink-colors') || {}).textContent || '[]');
    if (parsed.length) return parsed;
    return [
      { handle: 'black',  name: 'Black',  hex: '#1A1A1A', pantone_code: 'Pantone® Black 6 C' },
      { handle: 'white',  name: 'White',  hex: '#FFFFFF', pantone_code: '' },
      { handle: 'red',    name: 'Red',    hex: '#D0021B', pantone_code: 'Pantone® 186 C' },
      { handle: 'blue',   name: 'Blue',   hex: '#0052CC', pantone_code: 'Pantone® 286 C' },
      { handle: 'green',  name: 'Green',  hex: '#1A7F37', pantone_code: 'Pantone® 355 C' },
      { handle: 'orange', name: 'Orange', hex: '#E86A10', pantone_code: 'Pantone® 021 C' },
      { handle: 'yellow', name: 'Yellow', hex: '#FFCC00', pantone_code: 'Pantone® 102 C' },
    ];
  }());
  const faqTipBlocks = (function() {
    const parsed = JSON.parse((document.getElementById('ctb5-faq-tips') || {}).textContent || '[]');
    if (parsed.length) return parsed;
    return [
      { question: "What's the minimum order quantity?", answer: "There is no minimum — you can order a single roll. Try it at low risk, then scale up as the per-roll price drops." },
      { question: "How long does this take?", answer: "Production is one week or faster after you approve your proof. We send the free designer-polished proof within 12 hours of your order — approve it, and the clock starts." },
      { question: "Do I need a special dispenser?", answer: "Yes — water-activated tape requires a WAT dispenser to wet the adhesive before application. Don't have one? Contact us and we'll point you to the right one." },
      { question: "Is water-activated tape really tamper-evident?", answer: "Yes. Once it bonds to corrugated, it can't be removed without visibly tearing the box surface. It's also fiberglass-reinforced, so it can't be cut or peeled cleanly." },
      { question: "Is it eco-friendly?", answer: "Yes. Water-activated tape is paper-based, recyclable with the box, and contains no plastic film. If sustainable packaging matters to your brand, this is the tape to use." },
    ];
  }());

  // ===== State =====
  const state = {
    config: null,
    material: 'wat',
    grade: null,
    width: '3in',   // WAT is always 3in — no selector
    length: null,
    qty: null,
    tapeColorMode: 'neutral',
    tapeColor: null,
    printColors: '1',
    printColorSelections: {},
    pantonePrintCodes: {},
    artworkMode: 'upload',
    artworkUrl: null,
    artworkFilename: null,
    designerNotes: '',
    logoRepeat: 'normal',
    printLayout: 'horizontal',
    proofEmail: '',
    view: 'roll',
    discountCode: '',
    discountApplied: null,
  };

  const REPEAT_PITCHES = { tight: 90, normal: 140, spread: 200 };

  const GRADE_IMGS = {
    GP240:  'td-kraft-tape-grade-general-purpose.png',
    HD260:  'td-kraft-tape-grade-heavy-duty.png',
    IND280: 'td-kraft-tape-grade-industrial.png',
  };
  const LENGTH_IMGS = {
    '375ft': 'td-tape-wat-length-375ft-kraft.png',
    '450ft': 'td-tape-wat-length-450ft-kraft.png',
    '500ft': 'td-tape-wat-length-500ft-kraft.png',
  };
  const TAPE_COLOR_IMGS = {
    'kraft': 'td-tape-wat-brown.png',
    'white': 'td-tape-wat-white.png',
  };

  const $ = (sel, ctx) => (ctx || root).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || root).querySelectorAll(sel));
  const fmt = n => '$' + Number(n).toFixed(2);
  const fmt0 = n => '$' + Number(n).toFixed(0);

  fetch(root.dataset.configUrl).then(r => r.json()).then(cfg => {
    state.config = cfg;
    seedDefaults();
    restoreFromUrlOrStorage();
    bindStaticHandlers();
    renderAll();
    startTipRotator();
  });

  // ===== Defaults & persistence =====

  function seedDefaults() {
    const c = state.config;
    state.material = 'wat';
    state.width = '3in';
    const grades = currentGrades();
    const defGrade = grades.find(g => g.default) || grades[0];
    state.grade = defGrade ? defGrade.id : 'GP240';
    const lengths = currentLengths();
    const defLength = lengths.find(l => l.default) || lengths[0];
    state.length = defLength ? defLength.id : '375ft';
    const tiers = currentTiers();
    state.qty = tiers ? tiers[0].rolls : 6;
    const neutrals = neutralTapeColors();
    state.tapeColor = neutrals[0] ? neutrals[0].handle : 'kraft';
    state.printColorSelections = { '1': inkColorBlocks[0] ? inkColorBlocks[0].handle : 'black' };
  }

  function restoreFromUrlOrStorage() {
    try {
      const params = new URLSearchParams(location.search);
      const token = params.get(STATE_PARAM);
      if (token) { Object.assign(state, JSON.parse(atob(token))); enforceWat(); return; }
      const saved = sessionStorage.getItem(STORAGE_KEY);
      if (saved) { Object.assign(state, JSON.parse(saved)); enforceWat(); }
    } catch (e) { /* ignore */ }
  }

  function enforceWat() {
    state.material = 'wat';
    state.width = '3in';
    state.tapeColorMode = 'neutral'; // WAT has no color/pantone option
    reconcileAfterGradeChange();
  }

  function persist() {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(pickSlim())); } catch (e) { /* ignore */ }
  }

  function pickSlim() {
    return {
      grade: state.grade, length: state.length, qty: state.qty,
      tapeColor: state.tapeColor,
      printColors: state.printColors, printColorSelections: state.printColorSelections, pantonePrintCodes: state.pantonePrintCodes,
      artworkMode: state.artworkMode, designerNotes: state.designerNotes, logoRepeat: state.logoRepeat, printLayout: state.printLayout,
    };
  }

  function buildResumeToken() { return btoa(JSON.stringify(pickSlim())); }

  // ===== State helpers =====

  function currentGrades()  { return state.config.grades['wat'] || []; }
  function currentLengths() { return state.config.lengths['wat'] || []; }
  function skuKey()         { return ['wat', state.grade, '3in', state.length].join('|'); }
  function currentTiers()   { return state.config.pricing_matrix[skuKey()] || null; }

  function neutralTapeColors() { return tapeColorBlocks.filter(b => b.tier === 'neutral'); }

  function reconcileAfterGradeChange() {
    if (!currentGrades().some(g => g.id === state.grade)) {
      const def = currentGrades().find(g => g.default) || currentGrades()[0];
      state.grade = def && def.id;
    }
    if (!currentLengths().some(l => l.id === state.length)) {
      const def = currentLengths().find(l => l.default) || currentLengths()[0];
      state.length = def && def.id;
    }
    reconcileQty();
  }

  function reconcileQty() {
    const tiers = currentTiers();
    if (!tiers || !tiers.length) return;
    if (!tiers.some(t => t.rolls === state.qty)) state.qty = tiers[0].rolls;
  }

  // ===== Main render =====

  function renderAll() {
    renderTapeSection();
    renderPrintSection();
    renderArtworkSection();
    renderLadder();
    updatePrice();
    drawPreview();
    persist();
  }

  // ===== Section 1: YOUR TAPE =====

  function renderTapeSection() {
    const body = $('[data-ctb5-tape-body]');
    if (!body) return;

    body.innerHTML = `
      <div class="ctb5__field">
        <span class="ctb5__field-label">Grade</span>
        <div class="ctb5__card-grid ctb5__card-grid--3" data-ctb5-pills="grade">
          ${currentGrades().map(g => `
            <button type="button" class="ctb5__card-btn ${state.grade === g.id ? 'is-selected' : ''}" data-val="${g.id}">
              ${GRADE_IMGS[g.id] ? `<img class="ctb5__card-btn-img" src="${assetUrl(GRADE_IMGS[g.id])}" alt="${g.label}" onerror="this.style.display='none'">` : ''}
              <span class="ctb5__card-btn-label">${g.label}</span>
              ${g.badge ? `<span class="ctb5__card-badge">${g.badge}</span>` : ''}
            </button>`).join('')}
        </div>
        ${gradeDetailHTML()}
      </div>

      <div class="ctb5__field">
        <span class="ctb5__field-label">Length</span>
        <div class="ctb5__card-grid ctb5__card-grid--3" data-ctb5-pills="length">
          ${currentLengths().map(l => `
            <button type="button" class="ctb5__card-btn ${state.length === l.id ? 'is-selected' : ''}" data-val="${l.id}">
              <img class="ctb5__card-btn-img--sm" src="${assetUrl(LENGTH_IMGS[l.id] || '')}" alt="${l.label}" onerror="this.style.display='none'">
              <span class="ctb5__card-btn-label">${l.label}</span>
              ${l.badge ? `<span class="ctb5__card-badge">${l.badge}</span>` : ''}
            </button>`).join('')}
        </div>
      </div>

      <div class="ctb5__hint ctb5__hint--info">
        <strong>Dispenser required.</strong> Water-activated tape needs a WAT dispenser to wet the adhesive. Don't have one?
        <a href="/products/water-activated-tape-dispenser" style="color:var(--td-red)">Add a dispenser →</a>
      </div>
    `;

    $$('[data-ctb5-pills="grade"] .ctb5__card-btn', body).forEach(b =>
      b.addEventListener('click', () => { state.grade = b.dataset.val; reconcileAfterGradeChange(); renderAll(); }));
    $$('[data-ctb5-pills="length"] .ctb5__card-btn', body).forEach(b =>
      b.addEventListener('click', () => { state.length = b.dataset.val; reconcileQty(); renderAll(); }));
  }

  function assetUrl(filename) {
    const configUrl = root.dataset.configUrl || '';
    const base = configUrl.replace(/[^/?#]*(\?.*)?$/, '');
    return base + filename;
  }

  function gradeDetailHTML() {
    const g = currentGrades().find(x => x.id === state.grade);
    if (!g) return '';
    return `<div class="ctb5__hint">
      <strong>${g.supporting || ''}</strong>
      ${g.details && g.details.length ? `<ul style="margin:0.4rem 0 0;padding-left:1.2em">${g.details.map(d => `<li>${d}</li>`).join('')}</ul>` : ''}
    </div>`;
  }

  // ===== Section 2: YOUR PRINT =====
  // WAT: neutral-only (no color/pantone tabs)

  function renderPrintSection() {
    const body = $('[data-ctb5-print-body]');
    if (!body) return;
    const c = state.config;
    const numPrint = Number(state.printColors);
    const neutralColors = neutralTapeColors();

    body.innerHTML = `
      <div class="ctb5__field">
        <span class="ctb5__field-label">Tape base color</span>
        ${tapeColorCardsHTML(neutralColors)}
      </div>

      <div class="ctb5__field">
        <span class="ctb5__field-label">Number of ink colors</span>
        <div class="ctb5__tabs" data-ctb5-pills="printColors">
          ${c.print_colors.map(pc => `
            <button type="button" class="ctb5__tab ${state.printColors === pc.id ? 'is-selected' : ''}" data-val="${pc.id}">
              ${pc.label}<span class="ctb5__tab-meta">${pc.modifier_pct === 0 ? 'included' : '+' + pc.modifier_pct + '%'}</span>
            </button>`).join('')}
        </div>
        <div class="ctb5__print-slots">
          ${Array.from({length: numPrint}, (_, i) => inkSlotHTML(i + 1)).join('')}
        </div>
      </div>
    `;

    $$('[data-ctb5-tape-color]', body).forEach(b =>
      b.addEventListener('click', () => { state.tapeColor = b.dataset.ctb5TapeColor; renderPrintSection(); drawPreview(); }));
    $$('[data-ctb5-pills="printColors"] .ctb5__tab', body).forEach(b =>
      b.addEventListener('click', () => {
        state.printColors = b.dataset.val;
        for (let i = 1; i <= Number(state.printColors); i++) {
          if (!state.printColorSelections[String(i)]) state.printColorSelections[String(i)] = inkColorBlocks[0] ? inkColorBlocks[0].handle : 'black';
        }
        renderPrintSection(); updatePrice();
      }));
    $$('[data-ctb5-ink-color]', body).forEach(b =>
      b.addEventListener('click', () => {
        state.printColorSelections[b.dataset.slot] = b.dataset.ctb5InkColor;
        state.pantonePrintCodes[b.dataset.slot] = '';
        renderPrintSection(); drawPreview();
      }));
    $$('[data-ctb5-print-pantone]', body).forEach(input =>
      input.addEventListener('input', e => {
        state.pantonePrintCodes[input.dataset.slot] = e.target.value;
        if (e.target.value) state.printColorSelections[input.dataset.slot] = '__pantone__';
        updatePrice(); persist();
      }));
  }

  function tapeColorCardsHTML(colors) {
    if (!colors || !colors.length) return '';
    return `<div class="ctb5__color-cards">
      ${colors.map(c => {
        const img = TAPE_COLOR_IMGS[c.handle];
        return `
        <button type="button"
          class="ctb5__card-btn ctb5__card-btn--color ${state.tapeColor === c.handle ? 'is-selected' : ''}"
          data-ctb5-tape-color="${c.handle}">
          ${img
            ? `<img class="ctb5__card-btn-img--xs" src="${assetUrl(img)}" alt="${c.name}"
                onerror="this.onerror=null;this.style.display='none';var s=this.nextElementSibling;if(s)s.style.display='block'">
               <span class="ctb5__color-swatch-block" style="background:${c.hex};display:none"></span>`
            : `<span class="ctb5__color-swatch-block" style="background:${c.hex}"></span>`}
          <span class="ctb5__card-btn-label">${c.name}</span>
          ${c.pantone_code ? `<span class="ctb5__card-btn-pantone">${c.pantone_code}</span>` : ''}
        </button>`;
      }).join('')}
    </div>`;
  }

  function inkSlotHTML(slot) {
    const slotKey = String(slot);
    const selected = state.printColorSelections[slotKey] || (inkColorBlocks[0] ? inkColorBlocks[0].handle : 'black');
    const pantoneCode = state.pantonePrintCodes[slotKey] || '';
    const surcharge = state.config.tape_color_modes.pantone.flat_addon_per_color_usd;
    return `<div class="ctb5__print-slot">
      <div class="ctb5__print-slot-head">Ink color ${slot}</div>
      <div class="ctb5__ink-swatches">
        ${inkColorBlocks.map(ink => `
          <button type="button"
            class="ctb5__ink-sw ${selected === ink.handle ? 'is-selected' : ''}"
            style="background:${ink.hex}"
            title="${ink.name}"
            aria-label="${ink.name}"
            data-ctb5-ink-color="${ink.handle}"
            data-slot="${slotKey}">
          </button>`).join('')}
      </div>
      <input type="text" class="ctb5__input" placeholder="Need a different color? Enter your PANTONE&reg; code (+$${surcharge}/color)"
        data-ctb5-print-pantone data-slot="${slotKey}" value="${pantoneCode}">
    </div>`;
  }

  // ===== Section 3: YOUR ARTWORK =====

  function renderArtworkSection() {
    const body = $('[data-ctb5-artwork-body]');
    if (!body) return;
    const c = state.config;

    body.innerHTML = `
      <div class="ctb5__field">
        <span class="ctb5__field-label">Layout</span>
        <div class="ctb5__repeat-row" data-ctb5-layout-row>
          ${[['horizontal','Horizontal'],['vertical','Vertical'],['step-repeat','Step &amp; Repeat']].map(([id, label]) => `
            <button type="button" class="ctb5__repeat-opt ${state.printLayout === id ? 'is-selected' : ''}" data-layout="${id}">
              ${LAYOUT_SVGS[id]}
              <span class="ctb5__repeat-label">${label}</span>
            </button>`).join('')}
        </div>
        ${state.printLayout !== 'step-repeat' ? `
        <div class="ctb5__repeat-row ctb5__repeat-row--sub" data-ctb5-density-row>
          ${['tight','normal','spread'].map(id => `
            <button type="button" class="ctb5__repeat-opt ${state.logoRepeat === id ? 'is-selected' : ''}" data-density="${id}">
              ${DENSITY_SVGS[id]}
              <span class="ctb5__repeat-label">${id.charAt(0).toUpperCase() + id.slice(1)}</span>
            </button>`).join('')}
        </div>` : ''}
      </div>

      <div class="ctb5__field">
        <span class="ctb5__field-label">Artwork</span>
        <div class="ctb5__artwork-modes" data-ctb5-artwork-modes>
          ${c.artwork.modes.map(am =>
            `<button type="button" class="ctb5__pill ${state.artworkMode === am.id ? 'is-selected' : ''}" data-artwork-mode="${am.id}">${am.label}</button>`
          ).join('')}
        </div>
        ${artworkBodyHTML(c)}
      </div>

      <div class="ctb5__field">
        <span class="ctb5__field-label">Designer notes (optional)</span>
        <textarea class="ctb5__textarea" data-ctb5-notes placeholder="Notes for our designers — mention any special instructions, colors, or text">${state.designerNotes}</textarea>
      </div>
    `;

    $$('[data-ctb5-layout-row] .ctb5__repeat-opt', body).forEach(b =>
      b.addEventListener('click', () => { state.printLayout = b.dataset.layout; renderArtworkSection(); drawPreview(); persist(); }));
    $$('[data-ctb5-density-row] .ctb5__repeat-opt', body).forEach(b =>
      b.addEventListener('click', () => {
        state.logoRepeat = b.dataset.density;
        $$('[data-ctb5-density-row] .ctb5__repeat-opt', body).forEach(x => x.classList.toggle('is-selected', x === b));
        drawPreview(); persist();
      }));
    $$('[data-artwork-mode]', body).forEach(b =>
      b.addEventListener('click', () => { state.artworkMode = b.dataset.artworkMode; renderArtworkSection(); }));
    const notes = $('[data-ctb5-notes]', body);
    if (notes) notes.addEventListener('input', e => { state.designerNotes = e.target.value; persist(); });
    const fileInput = $('#ctb5-file', body);
    if (fileInput) {
      fileInput.addEventListener('change', e => handleFile(e.target.files[0]));
      const drop = $('[data-ctb5-drop]', body);
      if (drop) {
        ['dragover', 'dragleave', 'drop'].forEach(evt => drop.addEventListener(evt, e => e.preventDefault()));
        drop.addEventListener('drop', e => handleFile(e.dataTransfer.files[0]));
      }
    }
  }

  function artworkBodyHTML(c) {
    if (state.artworkMode === 'upload') {
      return `
        <div class="ctb5__upload" data-ctb5-drop>
          <input type="file" id="ctb5-file" accept="${c.artwork.accepted_types.join(',')}" hidden>
          <label for="ctb5-file" class="ctb5__upload-label">
            <span class="ctb5__upload-icon">&#11014;</span>
            <strong>Drag file or click to upload</strong>
            <span class="ctb5__upload-tip">Best results: square (1:1) .png, .svg, .pdf with transparent background</span>
            <small>${c.artwork.accepted_types.join(', ')} &middot; max ${c.artwork.max_size_mb}MB</small>
          </label>
        </div>
        <div class="ctb5__artwork-status" data-ctb5-art-status>${state.artworkFilename ? '&#10003; ' + state.artworkFilename : ''}</div>
      `;
    }
    if (state.artworkMode === 'later') {
      return `<div class="ctb5__later-hint">No problem. We'll email you after checkout to collect your artwork. Our designers will handle layout for you.</div>`;
    }
    return `<div class="ctb5__later-hint">Your design will be a typeset text mark. Tell us what to print in the notes.</div>`;
  }

  // ===== Sidebar: quantity ladder =====

  function renderLadder() {
    const body = $('[data-ctb5-ladder]');
    if (!body) return;
    const tiers = currentTiers();
    if (!tiers || !tiers.length) {
      body.innerHTML = `<div class="ctb5__warning">No pricing found. <a href="mailto:support@tapedudes.com">Email us for a quote.</a></div>`;
      return;
    }
    const baselinePpr = tiers[0].ppr;
    body.innerHTML = `
      <div class="ctb5__ladder" role="radiogroup" aria-label="Quantity">
        ${tiers.map((t, i) => {
          const each = applyModifiers(t.ppr);
          const total = each * t.rolls;
          const savePct = i === 0 ? 0 : Math.round((1 - t.ppr / baselinePpr) * 100);
          return `<button type="button" class="ctb5__rung ${state.qty === t.rolls ? 'is-selected' : ''}" data-rolls="${t.rolls}" role="radio" aria-checked="${state.qty === t.rolls}">
            <div class="ctb5__rung-left">
              <span class="ctb5__rung-qty">${t.rolls}<small> rolls</small></span>
              ${savePct > 0 ? `<span class="ctb5__rung-save">Save ${savePct}%</span>` : `<span class="ctb5__rung-save ctb5__rung-save--min">Min. order</span>`}
            </div>
            <div class="ctb5__rung-right">
              <span class="ctb5__rung-price">${fmt(each)}<small style="font-size:0.75em;font-weight:400;opacity:0.7">/roll</small></span>
              <span class="ctb5__rung-total">${fmt0(total)}</span>
            </div>
          </button>`;
        }).join('')}
      </div>
    `;
    $$('.ctb5__rung', body).forEach(b =>
      b.addEventListener('click', () => { state.qty = Number(b.dataset.rolls); renderLadder(); updatePrice(); }));
  }

  // ===== Pricing =====

  function applyModifiers(basePpr) {
    let p = basePpr;
    const pc = state.config.print_colors.find(x => x.id === state.printColors);
    if (pc && pc.modifier_pct) p *= (1 + pc.modifier_pct / 100);
    return p;
  }

  function priceEach() {
    const tiers = currentTiers();
    if (!tiers) return 0;
    const tier = tiers.find(t => t.rolls === state.qty) || tiers[0];
    return applyModifiers(tier.ppr);
  }

  function tapeSubtotal() { return priceEach() * state.qty; }

  function pantonePrintFee() {
    let fee = 0;
    const surcharge = state.config.tape_color_modes.pantone.flat_addon_per_color_usd;
    for (let i = 1; i <= Number(state.printColors); i++) {
      if ((state.pantonePrintCodes[String(i)] || '').trim()) fee += surcharge;
    }
    return fee;
  }

  function plateFee() { return state.config.fees.plate_fee_usd || 0; }
  function totalPrice() { return tapeSubtotal() + pantonePrintFee(); }

  function updatePrice() {
    if (!state.config) return;
    const each = priceEach();
    const total = totalPrice();

    const elEach  = $('[data-ctb5-price-each]');
    const elRolls = $('[data-ctb5-rolls]');
    const elTotal = $('[data-ctb5-price-total]');
    const elMoq   = $('[data-ctb5-moq]');
    if (elEach)  elEach.textContent  = fmt(each);
    if (elRolls) elRolls.textContent = state.qty;
    if (elTotal) elTotal.textContent = fmt(total);
    if (elMoq) {
      const tiers = currentTiers();
      // MOQ went to 1 on 2026-08-28, so there is no minimum to announce and
      // the old string rendered "Min. order: 1 rolls". Show the entry rung
      // instead, pluralised, and say nothing when the floor is a single roll.
      const minRolls = tiers ? tiers[0].rolls : 0;
      elMoq.textContent = !tiers ? ''
        : minRolls <= 1 ? 'No minimum order'
        : `Min. order: ${minRolls} rolls`;
    }

    const breakdown = $('[data-ctb5-breakdown]');
    if (breakdown) {
      const lines = [{ label: 'Tape', value: fmt(tapeSubtotal()) }];
      if (pantonePrintFee()) lines.push({ label: `PANTONE® print (${Math.round(pantonePrintFee() / state.config.tape_color_modes.pantone.flat_addon_per_color_usd)} color)`, value: fmt(pantonePrintFee()) });
      if (plateFee()) lines.push({ label: state.config.fees.plate_fee_label, value: fmt(plateFee()), free: true });
      lines.push({ label: 'Shipping', value: state.config.fees.shipping, isFree: state.config.fees.shipping === 'FREE' });

      let discountedTotal = total;
      if (state.discountApplied) {
        const dv = parseFloat(state.discountApplied.value);
        const discountAmt = state.discountApplied.value_type === 'percentage' ? total * dv / 100 : Math.min(dv, total);
        discountedTotal = total - discountAmt;
        lines.push({ label: `Discount (${state.discountApplied.code})`, value: '-' + fmt(discountAmt), isDiscount: true });
      }
      lines.push({ label: 'Total', value: state.discountApplied ? `<s class="ctb5__strike">${fmt(total)}</s> ${fmt(discountedTotal)}` : fmt(total), isTotal: true, isHtml: true });

      breakdown.innerHTML = lines.map(l => `
        <div class="ctb5__breakdown-row${l.isTotal ? ' ctb5__breakdown-total' : ''}">
          <span>${l.label}</span>
          ${l.free
            ? `<strong><s class="ctb5__strike">${l.value}</s> <span class="ctb5__free">FREE</span></strong>`
            : `<strong class="${l.isFree ? 'ctb5__free' : l.isDiscount ? 'ctb5__discount-value' : ''}">${l.isHtml ? l.value : l.value}</strong>`}
        </div>`).join('');
    }

    const stickyPrice = $('[data-ctb5-sticky-price]');
    const stickyMeta  = $('[data-ctb5-sticky-meta]');
    if (stickyPrice) stickyPrice.textContent = fmt(each);
    if (stickyMeta)  stickyMeta.textContent  = `${state.qty} rolls · ${fmt(total)}`;

    persist();
  }

  // ===== Canvas preview =====

  function getTapeColorHex() {
    const found = neutralTapeColors().find(c => c.handle === state.tapeColor);
    return found ? found.hex : '#C9A57B';
  }

  function getInkHex() {
    const primaryHandle = state.printColorSelections['1'];
    if (!primaryHandle || primaryHandle === '__pantone__') return '#111111';
    const found = inkColorBlocks.find(c => c.handle === primaryHandle);
    return found ? found.hex : '#111111';
  }

  function drawPreview() {
    const cv = $('[data-ctb5-preview]');
    if (!cv) return;
    const ctx = cv.getContext('2d');
    ctx.clearRect(0, 0, cv.width, cv.height);
    const bg = getTapeColorHex();
    state.view === 'box' ? drawBoxScene(ctx, bg, cv.width, cv.height) : drawRollScene(ctx, bg, cv.width, cv.height);
  }

  function drawRollScene(ctx, bg, W, H) {
    ctx.fillStyle = '#F5F2ED';
    ctx.fillRect(0, 0, W, H);

    const ty = Math.round(H * 0.3), th = Math.round(H * 0.4);
    ctx.fillStyle = bg;
    ctx.fillRect(0, ty, W, th);
    ctx.fillStyle = 'rgba(0,0,0,0.08)';
    ctx.fillRect(0, ty, W, 4);
    ctx.fillRect(0, ty + th - 4, W, 4);

    const gloss = ctx.createLinearGradient(0, ty, 0, ty + th);
    gloss.addColorStop(0,   'rgba(255,255,255,0)');
    gloss.addColorStop(0.3, 'rgba(255,255,255,0.12)');
    gloss.addColorStop(0.5, 'rgba(255,255,255,0.18)');
    gloss.addColorStop(0.7, 'rgba(255,255,255,0.12)');
    gloss.addColorStop(1,   'rgba(255,255,255,0)');
    ctx.fillStyle = gloss;
    ctx.fillRect(0, ty, W, th);

    ctx.strokeStyle = 'rgba(0,0,0,0.08)';
    ctx.setLineDash([4, 4]);
    const repeatW = REPEAT_PITCHES[state.logoRepeat] || 140;
    for (let x = repeatW; x < W; x += repeatW) {
      ctx.beginPath(); ctx.moveTo(x, ty); ctx.lineTo(x, ty + th); ctx.stroke();
    }
    ctx.setLineDash([]);

    drawTapePattern(ctx, 0, ty, W, th);
  }

  let _boxImg = null;
  let _boxImgLoading = false;

  function drawBoxScene(ctx, bg, W, H) {
    function render(img) {
      const imgAspect = img.width / img.height, canvasAspect = W / H;
      let sx, sy, sw, sh;
      if (imgAspect > canvasAspect) {
        sh = img.height; sw = img.height * canvasAspect; sx = (img.width - sw) / 2; sy = 0;
      } else {
        sw = img.width; sh = img.width / canvasAspect; sx = 0; sy = (img.height - sh) / 2;
      }
      ctx.drawImage(img, sx, sy, sw, sh, 0, 0, W, H);

      const tapeH = 52, seamY = Math.round(H * 0.56), tapeY = seamY - Math.round(tapeH / 2);
      ctx.save();
      ctx.beginPath(); ctx.rect(0, tapeY, W, tapeH); ctx.clip();
      ctx.fillStyle = bg; ctx.globalAlpha = 0.93; ctx.fillRect(0, tapeY, W, tapeH); ctx.globalAlpha = 1;
      ctx.fillStyle = 'rgba(0,0,0,0.15)';
      ctx.fillRect(0, tapeY, W, 3); ctx.fillRect(0, tapeY + tapeH - 3, W, 3);
      const gloss = ctx.createLinearGradient(0, tapeY, W, tapeY + tapeH);
      gloss.addColorStop(0, 'rgba(255,255,255,0)'); gloss.addColorStop(0.35, 'rgba(255,255,255,0.1)');
      gloss.addColorStop(0.5, 'rgba(255,255,255,0.15)'); gloss.addColorStop(0.65, 'rgba(255,255,255,0.1)');
      gloss.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = gloss; ctx.fillRect(0, tapeY, W, tapeH);
      ctx.restore();
      drawTapePattern(ctx, 0, tapeY, W, tapeH);
      const shadowGrad = ctx.createLinearGradient(0, tapeY + tapeH, 0, tapeY + tapeH + 8);
      shadowGrad.addColorStop(0, 'rgba(0,0,0,0.13)'); shadowGrad.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = shadowGrad; ctx.fillRect(0, tapeY + tapeH, W, 8);
    }

    if (_boxImg) { render(_boxImg); return; }
    ctx.fillStyle = '#F0EDE8'; ctx.fillRect(0, 0, W, H);
    if (!_boxImgLoading) {
      _boxImgLoading = true;
      const img = new Image();
      img.onload = () => { _boxImg = img; render(img); };
      img.onerror = () => { _boxImgLoading = false; };
      img.src = root.dataset.boxPhotoUrl;
    }
  }

  const PREVIEWABLE = ['.png', '.jpg', '.jpeg', '.gif', '.webp', '.svg'];
  function isPreviewable(fn) { if (!fn) return false; const l = fn.toLowerCase(); return PREVIEWABLE.some(e => l.endsWith(e)); }

  function drawTapePattern(ctx, x, y, w, h) {
    if (!state.artworkUrl) {
      ctx.save();
      ctx.fillStyle = 'rgba(0,0,0,0.25)';
      ctx.font = '13px sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.fillText('Upload artwork to preview', x + w / 2, y + h / 2);
      ctx.restore();
      return;
    }
    if (!isPreviewable(state.artworkFilename)) {
      ctx.save();
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.fillStyle = 'rgba(0,0,0,0.5)'; ctx.font = 'bold 13px sans-serif';
      ctx.fillText('✓ Artwork received — proof ready in 12h', x + w / 2, y + h / 2);
      ctx.restore();
      return;
    }
    const inkHex = getInkHex();
    const img = new Image();
    img.onload = () => {
      const off = document.createElement('canvas');
      off.width = w; off.height = h;
      const octx = off.getContext('2d');
      const layout = state.printLayout || 'horizontal';
      const pitch = REPEAT_PITCHES[state.logoRepeat] || 140;
      if (layout === 'horizontal') {
        const imgH = h * 0.72, imgW = (img.width / img.height) * imgH;
        for (let i = 0; i < w + pitch; i += pitch) octx.drawImage(img, i + (pitch - imgW) / 2, (h - imgH) / 2, imgW, imgH);
      } else if (layout === 'vertical') {
        const rotH = h * 0.78, rotW = (img.width / img.height) * rotH;
        const vPitch = Math.max(pitch, rotW + 16);
        for (let cx = vPitch / 2; cx < w + vPitch; cx += vPitch) {
          octx.save(); octx.translate(cx, h / 2); octx.rotate(-Math.PI / 2);
          octx.drawImage(img, -rotH / 2, -rotW / 2, rotH, rotW); octx.restore();
        }
      } else {
        const rowH = h / 2, imgH = rowH * 0.72, imgW = (img.width / img.height) * imgH;
        const sPitch = Math.max(96, imgW + 20);
        for (let i = 0; i < w + sPitch; i += sPitch) octx.drawImage(img, i + (sPitch - imgW) / 2, (rowH - imgH) / 2, imgW, imgH);
        for (let i = -sPitch / 2; i < w + sPitch; i += sPitch) octx.drawImage(img, i + (sPitch - imgW) / 2, rowH + (rowH - imgH) / 2, imgW, imgH);
      }
      octx.globalCompositeOperation = 'source-in';
      octx.fillStyle = inkHex; octx.fillRect(0, 0, w, h);
      ctx.drawImage(off, x, y);
    };
    img.src = state.artworkUrl;
  }

  function handleFile(file) {
    if (!file) return;
    const status = $('[data-ctb5-art-status]');
    if (file.size > state.config.artwork.max_size_mb * 1024 * 1024) {
      if (status) status.textContent = `File too large. Max ${state.config.artwork.max_size_mb}MB.`;
      return;
    }
    state.artworkFilename = file.name;
    state.artworkFile = file;   // retained for the order-time Cloudinary upload (see addToCart)
    const reader = new FileReader();
    reader.onload = e => {
      state.artworkUrl = e.target.result;
      if (status) status.textContent = '✓ ' + file.name;
      drawPreview();
    };
    reader.readAsDataURL(file);
  }

  // ===== FAQ tip rotator =====

  let tipTimer = null;
  let tipIndex = 0;

  function startTipRotator() {
    const card = $('[data-ctb5-faq-card]');
    if (!card || !faqTipBlocks.length) return;
    const tipQ   = $('[data-ctb5-tip-q]', card);
    const tipA   = $('[data-ctb5-tip-a]', card);
    const dotsEl = $('[data-ctb5-tip-dots]', card);
    if (!tipQ || !tipA) return;

    if (dotsEl) {
      dotsEl.innerHTML = '';
      faqTipBlocks.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button'; dot.className = 'ctb5__tip-dot'; dot.setAttribute('aria-label', 'Tip ' + (i + 1));
        dot.addEventListener('click', () => { showTip(i); schedule(); });
        dotsEl.appendChild(dot);
      });
    }

    function showTip(idx) {
      tipIndex = (idx + faqTipBlocks.length) % faqTipBlocks.length;
      const tip = faqTipBlocks[tipIndex];
      tipQ.textContent = tip.question || '';
      tipA.innerHTML   = tip.answer || '';
      if (dotsEl) {
        Array.from(dotsEl.children).forEach((d, i) => d.classList.toggle('is-active', i === tipIndex));
      }
    }

    function schedule() {
      clearTimeout(tipTimer);
      tipTimer = setTimeout(() => { showTip(tipIndex + 1); schedule(); }, 5000);
    }

    card.addEventListener('mouseenter', () => clearTimeout(tipTimer));
    card.addEventListener('mouseleave', schedule);

    let touchStartX = 0;
    card.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
    card.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) { showTip(tipIndex + (dx < 0 ? 1 : -1)); schedule(); }
    }, { passive: true });

    showTip(0);
    schedule();
  }

  // ===== Static handlers =====

  function bindStaticHandlers() {
    $$('[data-ctb5-view]').forEach(b =>
      b.addEventListener('click', () => {
        state.view = b.dataset.ctb5View;
        $$('[data-ctb5-view]').forEach(x => x.classList.toggle('is-active', x === b));
        drawPreview();
      }));

    const addBtn = $('[data-ctb5-add]');
    if (addBtn) addBtn.addEventListener('click', openProofModal);
    const addMobileBtn = $('[data-ctb5-add-mobile]');
    if (addMobileBtn) addMobileBtn.addEventListener('click', openProofModal);

    const proofDialog = $('[data-ctb5-proof-dialog]');
    if (proofDialog) {
      const closeBtn   = $('[data-ctb5-proof-close]');
      const cancelBtn  = $('[data-ctb5-proof-cancel]');
      const confirmBtn = $('[data-ctb5-proof-confirm]');
      if (closeBtn)   closeBtn.addEventListener('click',   () => proofDialog.close());
      if (cancelBtn)  cancelBtn.addEventListener('click',  () => proofDialog.close());
      if (confirmBtn) confirmBtn.addEventListener('click', confirmAndAddToCart);
    }

    const quoteBtn    = $('[data-ctb5-quote]');
    const quoteDialog = $('[data-ctb5-quote-dialog]');
    if (quoteBtn && quoteDialog) {
      quoteBtn.addEventListener('click', () => {
        if (quoteDialog.showModal) quoteDialog.showModal(); else quoteDialog.setAttribute('open', '');
      });
      const quoteCancelBtn = $('[data-ctb5-quote-cancel]');
      if (quoteCancelBtn) quoteCancelBtn.addEventListener('click', e => { e.preventDefault(); quoteDialog.close(); });
      const quoteForm = $('[data-ctb5-quote-form]');
      if (quoteForm) quoteForm.addEventListener('submit', handleQuoteSubmit);
    }

    const guideDialog = $('[data-ctb5-guide-dialog]');
    const guideBody   = $('[data-ctb5-guide-body]');
    $$('[data-ctb5-help]').forEach(b =>
      b.addEventListener('click', () => {
        if (guideBody) guideBody.innerHTML = guideContent(b.dataset.ctb5Help);
        if (guideDialog) {
          if (guideDialog.showModal) guideDialog.showModal(); else guideDialog.setAttribute('open', '');
        }
      }));
    const guideClose = $('[data-ctb5-guide-close]');
    if (guideClose && guideDialog) guideClose.addEventListener('click', () => guideDialog.close());

    bindCouponHandlers();
  }

  // ===== Proof modal =====

  function openProofModal() {
    // Require an upload: block checkout when "Upload now" is selected but no file
    // is attached. "Plain text only" (and any non-upload mode) is exempt.
    if (state.artworkMode === 'upload' && !state.artworkFile) {
      const status = $('[data-ctb5-art-status]');
      if (status) status.textContent = 'Please upload your artwork to continue.';
      const modes = $('[data-ctb5-artwork-modes]');
      if (modes && modes.scrollIntoView) modes.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    const dialog = $('[data-ctb5-proof-dialog]');
    if (!dialog) { addToCart(); return; }

    const approveCb  = $('[data-ctb5-proof-approve]');
    const confirmBtn = $('[data-ctb5-proof-confirm]');
    if (approveCb && confirmBtn) {
      approveCb.checked = false;
      confirmBtn.disabled = true; confirmBtn.style.opacity = '0.45';
      approveCb.onchange = () => {
        confirmBtn.disabled = !approveCb.checked;
        confirmBtn.style.opacity = approveCb.checked ? '' : '0.45';
      };
    }
    const emailInput = $('[data-ctb5-proof-email]');
    if (emailInput && state.proofEmail) emailInput.value = state.proofEmail;
    const errEl = $('[data-ctb5-proof-error]');
    if (errEl) errEl.textContent = '';

    if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');

    const proofCv = $('[data-ctb5-proof-canvas]');
    if (proofCv) drawBoxScene(proofCv.getContext('2d'), getTapeColorHex(), proofCv.width, proofCv.height);
  }

  async function confirmAndAddToCart() {
    const emailInput = $('[data-ctb5-proof-email]');
    const errEl = $('[data-ctb5-proof-error]');
    const email = emailInput ? emailInput.value.trim() : '';
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (errEl) errEl.textContent = 'Please enter a valid email address so we can send your proof.';
      if (emailInput) emailInput.focus();
      return;
    }
    state.proofEmail = email;
    const dialog = $('[data-ctb5-proof-dialog]');
    if (dialog) dialog.close();
    await addToCart();
  }

  // ===== Checkout Bridge =====

  // ── Cloudinary capture (order-time) ──────────────────────────────
  // Same unsigned preset as stickers/proofs. `auto` (not `image`) so
  // .ai/.eps/.psd land as raw instead of 400-ing the image pipeline.
  // td-sticker-preview.js (window.TDStickerPreview) isn't loaded on tape
  // PDPs, so the uploader is inlined here rather than shared.
  var CLOUDINARY_UPLOAD = {
    url:    'https://api.cloudinary.com/v1_1/dsbz1mtmr/auto/upload',
    preset: 'tapedudes_unsigned',
    folder: 'orders',
  };

  /* ── SVG normalisation ────────────────────────────────────────────────
     Cloudinary sniffs an SVG's format from its FIRST BYTES. A file that does
     not begin with an XML declaration sniffs as `raw`, and the unsigned preset
     rejects it: 400 "Raw file format svg not allowed" — measured 2026-08-31 on
     auto/upload, image/upload and raw/upload alike. Illustrator "Export As" and
     Figma both write SVGs without the declaration. Order #2869 lost its artwork
     this way. A BOM is tolerated but leading whitespace is NOT, so the
     declaration has to end up at byte 0.
     Fails open: any unexpected file, or any read error, uploads unchanged. */
  var TD_XML_DECL = '<?xml version="1.0" encoding="UTF-8"?>\n';

  function normalizeSvg(file) {
    var name = file && file.name ? String(file.name).toLowerCase() : '';
    var looksSvg = !!file && (file.type === 'image/svg+xml' || /\.svg$/.test(name));
    if (!looksSvg || !file.slice || !file.slice(0, 1).arrayBuffer) return Promise.resolve(file);

    return file.slice(0, 1024).arrayBuffer().then(function (buf) {
      var b = new Uint8Array(buf), i = 0;
      if (b[0] === 0xEF && b[1] === 0xBB && b[2] === 0xBF) i = 3;                 // BOM
      while (i < b.length && (b[i] === 0x20 || b[i] === 0x09 || b[i] === 0x0A || b[i] === 0x0D)) i++;
      var head = new TextDecoder().decode(b.subarray(i));

      // Already declared and already at byte 0 — leave the bytes alone.
      if (/^<\?xml[\s?]/.test(head)) return i === 0 ? file : new File([file.slice(i)], file.name, { type: 'image/svg+xml' });
      // Named .svg but not SVG markup — never rewrite it, that would corrupt it.
      if (!/<svg[\s>]/i.test(head)) return file;
      return new File([TD_XML_DECL, file.slice(i)], file.name, { type: 'image/svg+xml' });
    })['catch'](function () { return file; });
  }

  function uploadArtwork(file) {
    return normalizeSvg(file).then(f => {
      const fd = new FormData();
      fd.append('file', f);
      fd.append('upload_preset', CLOUDINARY_UPLOAD.preset);
      fd.append('folder', CLOUDINARY_UPLOAD.folder);
      return fetch(CLOUDINARY_UPLOAD.url, { method: 'POST', body: fd })
        .then(res => { if (!res.ok) throw new Error('upload HTTP ' + res.status); return res.json(); })
        .then(j => { if (!j || !j.public_id) throw new Error('no public_id');
                     return { secure_url: j.secure_url, public_id: j.public_id }; });
    });
  }

  async function computeHmacHex(payload, nonce) {
    const enc = new TextEncoder();
    const key = await crypto.subtle.importKey('raw', enc.encode(nonce), { name: 'HMAC', hash: 'SHA-256' }, false, ['sign']);
    const sig = await crypto.subtle.sign('HMAC', key, enc.encode(JSON.stringify(payload)));
    return Array.from(new Uint8Array(sig)).map(b => b.toString(16).padStart(2, '0')).join('');
  }

  async function addToCart() {
    const addBtn       = $('[data-ctb5-add]');
    const mobileAddBtn = $('[data-ctb5-add-mobile]');
    [addBtn, mobileAddBtn].forEach(btn => { if (btn) { btn.disabled = true; btn.textContent = 'Preparing your checkout…'; } });

    const endpoint  = root.dataset.checkoutEndpoint;
    const nonce     = root.dataset.signingNonce;
    const variantId = root.dataset.variantId;

    const spec = {
      material: 'wat',
      grade: state.grade,
      width: '3in',
      length: state.length,
      qty: state.qty,
      tapeColor: state.tapeColor,
      printColors: state.printColors,
      printColorSelections: state.printColorSelections,
      pantonePrintCodes: state.pantonePrintCodes,
      artworkMode: state.artworkMode,
      artworkFilename: state.artworkFilename || '',
      designerNotes: state.designerNotes || '',
      printLayout: state.printLayout,      // horizontal | vertical | step-repeat
      logoRepeat: state.logoRepeat,        // tight | normal | spread
      proof_email: state.proofEmail || '',
    };

    const payload = { product_type: root.dataset.productType || 'custom-water-activated-tape', variant_id: variantId, quantity: state.qty, spec };
    if (state.discountApplied) payload.discount_code = state.discountApplied.code;

    // Upload the ORIGINAL selected file to Cloudinary and attach it to the spec
    // BEFORE the HMAC is computed — payload.spec is the same object reference, so
    // mutating it here is covered by the signature. Mutating after signing would
    // 400 the bridge. Failure never blocks checkout: flag it and proceed.
    if (state.artworkFile) {
      try {
        const up = await uploadArtwork(state.artworkFile);
        spec.artwork_url = up.secure_url;
        spec.artwork_public_id = up.public_id;
      } catch (err) {
        console.warn('[wat-v5] order-time artwork upload failed', err);
        spec.artwork_upload_status = 'failed';
      }
    }

    try {
      const signature = await computeHmacHex(payload, nonce);
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...payload, nonce, signature }),
      });
      const data = await res.json();
      if (!res.ok || !data.invoiceUrl) throw new Error(data.error || ('HTTP ' + res.status));
      window.location.href = data.invoiceUrl;
    } catch (e) {
      console.error('[wat-v5] checkout bridge failed', e);
      [addBtn, mobileAddBtn].forEach(btn => {
        if (btn) { btn.disabled = false; btn.textContent = 'Continue to Checkout'; }
      });
      alert('Could not start checkout: ' + e.message + '\n\nPlease try again or email support@tapedudes.com.');
    }
  }

  // ===== Quote =====

  async function handleQuoteSubmit(e) {
    e.preventDefault();
    const emailEl  = $('[data-ctb5-quote-email]');
    const nameEl   = $('[data-ctb5-quote-name]');
    const status   = $('[data-ctb5-quote-status]');
    const email    = emailEl ? emailEl.value.trim() : '';
    const name     = nameEl ? nameEl.value.trim() : '';
    if (!email) return;
    const token = buildResumeToken();
    const resumeUrl = location.origin + location.pathname + '?' + STATE_PARAM + '=' + encodeURIComponent(token);
    const summary = {
      email, name, resume_url: resumeUrl,
      material: 'wat', grade: state.grade, width: '3in', length: state.length, qty: state.qty,
      tape_color: state.tapeColor, print_colors: state.printColors,
      price_per_roll: priceEach().toFixed(2), total: totalPrice().toFixed(2),
    };
    if (status) status.textContent = 'Saving your quote…';
    try {
      const fd = new FormData();
      fd.append('form_type', 'customer'); fd.append('utf8', '✓');
      fd.append('contact[email]', email);
      if (name) fd.append('contact[first_name]', name);
      fd.append('contact[tags]', state.config.klaviyo.shopify_quote_tag);
      fd.append('contact[note]', JSON.stringify(summary));
      await fetch('/contact', { method: 'POST', body: fd });
      if (status) status.innerHTML = '✓ Quote saved. Resume link: <a href="' + resumeUrl + '">' + resumeUrl + '</a>';
      try { await navigator.clipboard.writeText(resumeUrl); } catch (_) {}
    } catch (err) {
      if (status) status.textContent = 'Could not save quote. Please email support@tapedudes.com.';
    }
  }

  // ===== Coupon =====

  async function applyDiscountCode(rawCode) {
    const couponInput    = $('[data-ctb5-coupon-input]');
    const couponApplyBtn = $('[data-ctb5-coupon-apply]');
    const couponMessage  = $('[data-ctb5-coupon-message]');
    const couponApplied  = $('[data-ctb5-coupon-applied]');
    const couponFields   = $('[data-ctb5-coupon-fields]');

    if (!rawCode || !/^[A-Za-z0-9_-]{1,50}$/.test(rawCode.trim())) {
      if (couponMessage) { couponMessage.textContent = 'Please enter a valid code (letters, numbers, hyphens).'; couponMessage.className = 'ctb5__coupon-message ctb5__coupon-message--error'; }
      return;
    }
    const code = rawCode.trim().toUpperCase();

    if (couponApplyBtn) { couponApplyBtn.disabled = true; couponApplyBtn.textContent = 'Validating…'; }
    if (couponMessage)  { couponMessage.textContent = ''; couponMessage.className = 'ctb5__coupon-message'; }

    const endpoint = root.dataset.checkoutEndpoint;
    const nonce = root.dataset.signingNonce;
    const validationPayload = { action: 'validate-discount', code };

    try {
      const signature = await computeHmacHex(validationPayload, nonce);
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...validationPayload, nonce, signature }),
      });
      const data = await res.json();
      if (data.valid) {
        state.discountApplied = { code: data.code, value_type: data.value_type, value: data.value, displayValue: data.displayValue };
        state.discountCode = data.code;
        if (couponInput)    couponInput.disabled = true;
        if (couponApplyBtn) { couponApplyBtn.disabled = true; couponApplyBtn.textContent = 'Apply'; }
        if (couponFields)   couponFields.hidden = true;
        if (couponApplied) {
          couponApplied.hidden = false;
          const codeEl  = $('[data-ctb5-coupon-applied-code]');
          const valueEl = $('[data-ctb5-coupon-applied-value]');
          if (codeEl)  codeEl.textContent  = data.code;
          if (valueEl) valueEl.textContent = data.displayValue;
        }
        updatePrice();
      } else {
        if (couponMessage)  { couponMessage.textContent = data.message || 'Invalid coupon code.'; couponMessage.className = 'ctb5__coupon-message ctb5__coupon-message--error'; }
        if (couponApplyBtn) { couponApplyBtn.disabled = false; couponApplyBtn.textContent = 'Apply'; }
      }
    } catch (e) {
      if (couponMessage)  { couponMessage.textContent = "Couldn't validate — try again or apply at checkout."; couponMessage.className = 'ctb5__coupon-message ctb5__coupon-message--warn'; }
      if (couponApplyBtn) { couponApplyBtn.disabled = false; couponApplyBtn.textContent = 'Apply'; }
    }
  }

  function removeDiscount() {
    state.discountApplied = null; state.discountCode = '';
    const couponInput    = $('[data-ctb5-coupon-input]');
    const couponApplyBtn = $('[data-ctb5-coupon-apply]');
    const couponMessage  = $('[data-ctb5-coupon-message]');
    const couponApplied  = $('[data-ctb5-coupon-applied]');
    const couponFields   = $('[data-ctb5-coupon-fields]');
    if (couponInput)    { couponInput.disabled = false; couponInput.value = ''; }
    if (couponApplyBtn) { couponApplyBtn.disabled = false; couponApplyBtn.textContent = 'Apply'; }
    if (couponMessage)  { couponMessage.textContent = ''; couponMessage.className = 'ctb5__coupon-message'; }
    if (couponApplied)  couponApplied.hidden = true;
    if (couponFields)   couponFields.hidden = false;
    updatePrice();
  }

  function bindCouponHandlers() {
    const couponInput     = $('[data-ctb5-coupon-input]');
    const couponApplyBtn  = $('[data-ctb5-coupon-apply]');
    const couponRemoveBtn = $('[data-ctb5-coupon-remove]');
    const couponNoCode    = $('[data-ctb5-coupon-no-code]');

    if (couponApplyBtn && couponInput) {
      couponApplyBtn.addEventListener('click', () => applyDiscountCode(couponInput.value));
      couponInput.addEventListener('keydown', e => { if (e.key === 'Enter') applyDiscountCode(couponInput.value); });
    }
    if (couponRemoveBtn) couponRemoveBtn.addEventListener('click', removeDiscount);
    if (couponNoCode) {
      couponNoCode.addEventListener('click', e => {
        e.preventDefault();
        const target = document.querySelector('#td-footer-welcome-signup');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  // ===== Guide =====

  function guideContent(key) {
    const guides = {
      tape: `<h3>Choosing your tape</h3>
        <p><strong>Grade</strong></p>
        <p><strong>General Purpose 240</strong> — handles 0–30 lb packages. The most popular choice for everyday e-commerce shipping.</p>
        <p><strong>Heavy Duty 260</strong> — for 30–60 lb packages. Tighter, thicker fiberglass reinforcement pattern.</p>
        <p><strong>Industrial 280</strong> — for 50–90 lb packages. The densest reinforcement strands for the heaviest cargo.</p>
        <p><strong>Length</strong> — 375 ft is the standard for most hand dispensers. 450 ft and 500 ft reduce roll changes for high-volume shippers.</p>
        <p><strong>Dispenser</strong> — WAT requires a water-activated tape dispenser to wet the gummed adhesive before application.</p>`,
      print: `<h3>Choosing your print</h3>
        <p><strong>Tape base color</strong> — Kraft Natural is the classic eco look. White provides stronger contrast for most logos.</p>
        <p><strong>Ink colors</strong> — 1 color is included. 2 colors adds 20%/roll. 3 colors adds 30%/roll. WAT prints sharp at up to 3 colors.</p>`,
      artwork: `<h3>Artwork &amp; layout</h3>
        <p><strong>Layout</strong> — Horizontal is the most common. Vertical rotates your logo 90°. Step &amp; Repeat creates a brick pattern across the tape.</p>
        <p><strong>Accepted formats</strong> — AI, EPS, PDF, PSD, SVG, PNG, JPG. Vector preferred for sharpest results.</p>
        <p><strong>Upload later</strong> — If you don't have artwork ready, select "I'll email it later" and our team will follow up after checkout.</p>
        <p><strong>Lead time</strong> — one week or faster from proof approval. Your proof arrives within 12 hours of ordering.</p>`,
    };
    return guides[key] || '';
  }

  // ===== SVGs =====

  const DENSITY_SVGS = {
    tight:  `<svg class="ctb5__repeat-svg" width="80" height="24" viewBox="0 0 80 24" xmlns="http://www.w3.org/2000/svg"><rect x="2"  y="6" width="11" height="12" rx="2" fill="currentColor" opacity="0.55"/><rect x="17" y="6" width="11" height="12" rx="2" fill="currentColor" opacity="0.55"/><rect x="32" y="6" width="11" height="12" rx="2" fill="currentColor" opacity="0.55"/><rect x="47" y="6" width="11" height="12" rx="2" fill="currentColor" opacity="0.55"/><rect x="62" y="6" width="11" height="12" rx="2" fill="currentColor" opacity="0.55"/></svg>`,
    normal: `<svg class="ctb5__repeat-svg" width="80" height="24" viewBox="0 0 80 24" xmlns="http://www.w3.org/2000/svg"><rect x="2"  y="6" width="20" height="12" rx="2" fill="currentColor" opacity="0.55"/><rect x="30" y="6" width="20" height="12" rx="2" fill="currentColor" opacity="0.55"/><rect x="58" y="6" width="20" height="12" rx="2" fill="currentColor" opacity="0.55"/></svg>`,
    spread: `<svg class="ctb5__repeat-svg" width="80" height="24" viewBox="0 0 80 24" xmlns="http://www.w3.org/2000/svg"><rect x="2"  y="6" width="34" height="12" rx="2" fill="currentColor" opacity="0.55"/><rect x="44" y="6" width="34" height="12" rx="2" fill="currentColor" opacity="0.55"/></svg>`,
  };

  const LAYOUT_SVGS = {
    horizontal:    `<svg class="ctb5__repeat-svg" width="80" height="30" viewBox="0 0 80 30" xmlns="http://www.w3.org/2000/svg"><rect x="2"  y="9" width="30" height="12" rx="2" fill="currentColor" opacity="0.55"/><rect x="44" y="9" width="30" height="12" rx="2" fill="currentColor" opacity="0.55"/></svg>`,
    vertical:      `<svg class="ctb5__repeat-svg" width="80" height="30" viewBox="0 0 80 30" xmlns="http://www.w3.org/2000/svg"><rect x="8"  y="3" width="12" height="24" rx="2" fill="currentColor" opacity="0.55"/><rect x="30" y="3" width="12" height="24" rx="2" fill="currentColor" opacity="0.55"/><rect x="52" y="3" width="12" height="24" rx="2" fill="currentColor" opacity="0.55"/></svg>`,
    'step-repeat': `<svg class="ctb5__repeat-svg" width="80" height="30" viewBox="0 0 80 30" xmlns="http://www.w3.org/2000/svg"><rect x="2"  y="2"  width="22" height="11" rx="2" fill="currentColor" opacity="0.55"/><rect x="30" y="2"  width="22" height="11" rx="2" fill="currentColor" opacity="0.55"/><rect x="58" y="2"  width="22" height="11" rx="2" fill="currentColor" opacity="0.55"/><rect x="16" y="17" width="22" height="11" rx="2" fill="currentColor" opacity="0.55"/><rect x="44" y="17" width="22" height="11" rx="2" fill="currentColor" opacity="0.55"/></svg>`,
  };

})();
